import React, { useEffect, useState } from 'react'
import Hero from './Hero'
import Features from './Features'
import AdditionalFeatures from './AdditionalFeatures'
import RateCalculator from './RateCalculator'
import FAQs from './FAQs'
import Footer from './Footer'

const Home = ({data}) => {
  const { rateCalculator, showAdditionalFeatures } = data;
  const [ipAddress, setIpAddress] = useState('');

  useEffect(() => {
    const fetchIpAddress = async () => {
      try {
        const response = await fetch('https://api.ipify.org?format=json');
        const data = await response.json();
        setIpAddress(data.ip);
      } catch (error) {
        console.error('Failed to fetch IP address:', error);
      }
    };
    fetchIpAddress();
  }, []);

  return (
    <>
        <Hero data={data} ipAddress={ipAddress}/>
        <Features data={data} />
        {showAdditionalFeatures !== false && <AdditionalFeatures data={data} />}
        {rateCalculator?.enabled && <RateCalculator data={data} />}
        <FAQs data={data} />
        <Footer data={data} ipAddress={ipAddress}/> 
    </>
  )
}

export default Home
